export default class ApiService {

	static get $inject(){
		return [
			'$q', '$http', '$cookies',
			'ApiService'
		];
	}

	constructor($q, $http, $cookies,
	            ApiService){

		this.api = ApiService.api;
		this.errors = ApiService.errors;
		this.successes = ApiService.successes;
		
		this.$q = $q;
		this.$http = $http;
		this.$cookies = $cookies;

	}

	//a.res(href="https://en.wikipedia.org/wiki/Snake_case", target="_blank") Snake Case.

	get service(){
		return {
			getPanelInfo: {
				name:'getPanelInfo',
				humanName:'Get Panel Info',
				request: {
					type: 'GET',
					route: '/personal/access/getPanelInfo',
					data: [],
					example: angular.toJson({})
				},
				response: {
					success: { data: [
					] },
					error: { data: [
						this.errors.status,
						this.errors.state,
						this.errors.message
					] }
				},
				submit: (data)=>
					this.$http({
						url: this.api + '/personal/access/getPanelInfo',
						method: 'GET',
						data: data,
						headers: { Authorization: 'Bearer ' + this.$cookies.get('token') }
					})
			},
			getEthernetInfo: {
				name:'getEthernetInfo',
				humanName:'getEthernetInfo',
				request: {
					type: 'GET',
					route: '/personal/access/getEthernetInfo',
					data: [],
					example: angular.toJson({})
				},
				response: {
					success: { data: [
					] },
					error: { data: [
						this.errors.status,
						this.errors.state,
						this.errors.message
					] }
				},
				submit: (data)=>
					this.$http({
						url: this.api + '/personal/access/getEthernetInfo',
						method: 'GET',
						data: data,
						headers: { Authorization: 'Bearer ' + this.$cookies.get('token') }
					})
			},
			getBatteryVoltage: {
				name:'getBatteryVoltage',
				humanName:'getBatteryVoltage',
				request: {
					type: 'GET',
					route: '/personal/access/getBatteryVoltage',
					data: [],
					example: angular.toJson({})
				},
				response: {
					success: { data: [
					] },
					error: { data: [
						this.errors.status,
						this.errors.state,
						this.errors.message
					] }
				},
				submit: (data)=>
					this.$http({
						url: this.api + '/personal/access/getBatteryVoltage',
						method: 'GET',
						data: data,
						headers: { Authorization: 'Bearer ' + this.$cookies.get('token') }
					})
			},
			getGsmModuleInfo: {
				name:'getGsmModuleInfo',
				humanName:'getGsmModuleInfo',
				request: {
					type: 'GET',
					route: '/personal/access/getGsmModuleInfo',
					data: [],
					example: angular.toJson({})
				},
				response: {
					success: { data: [
					] },
					error: { data: [
						this.errors.status,
						this.errors.state,
						this.errors.message
					] }
				},
				submit: (data)=>
					this.$http({
						url: this.api + '/personal/access/getGsmModuleInfo',
						method: 'GET',
						data: data,
						headers: { Authorization: 'Bearer ' + this.$cookies.get('token') }
					})
			}


		}
	}

}






/** WEBPACK FOOTER **
 ** ./src/main/apiTest/services/api.service.personal.access.info.js
 **/